__turbopack_context__.v({
  "breadcrumbs": "Breadcrumbs-module-scss-module__HoB1Ja__breadcrumbs",
  "crumb": "Breadcrumbs-module-scss-module__HoB1Ja__crumb",
  "current-page": "Breadcrumbs-module-scss-module__HoB1Ja__current-page",
  "link": "Breadcrumbs-module-scss-module__HoB1Ja__link",
});
